import { Track } from './track';

export class Session {
  id: number;
  agendaId: number;
  startTime: string;
  minutesDuration: number;
  tracks: Track[];
}
